import React, { useState, useRef, useEffect } from "react";

function LoginForm({ onLogin, onGoToRegister }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Added state
  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://resumefuel.xyz/resume/src/login.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (data.success) {
        onLogin(data.user);
      } else {
        setError(data.message || "Invalid email or password.");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form-sec">
      <h2 style={{ marginBottom: 20 }}>Login to Continue</h2>

      {error && <p style={{ color: "red", marginBottom: 10 }}>{error}</p>}

      <input
        ref={emailRef}
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        style={inputStyle}
        autoComplete="email"
      />

      <div style={{ position: "relative", marginBottom: 15 }}>
        <input
          type={showPassword ? "text" : "password"} // Toggle type
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ ...inputStyle, paddingRight: 60 }} // extra space for button
          autoComplete="current-password"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          style={showHideButtonStyle}
        >
          {showPassword ? "Hide" : "Show"}
        </button>
      </div>

      <button type="submit" style={buttonStyle} disabled={loading}>
        {loading ? "Logging in..." : "Login"}
      </button>

      <p style={{ marginTop: 10 }}>
        Don’t have an account?{" "}
        <button type="button" onClick={onGoToRegister} style={linkButtonStyle}>
          Register here
        </button>
      </p>
    </form>
  );
}

// --- Styles ---
const inputStyle = {
  marginBottom: 15,
  padding: 10,
  borderRadius: 4,
  border: "1px solid #ccc",
  fontSize: 14,
  boxSizing: "border-box",
  width: "100%",
};

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#0070ba",
  color: "white",
  border: "none",
  borderRadius: 4,
  fontSize: 16,
  cursor: "pointer",
};

const showHideButtonStyle = {
  position: "absolute",
  right: 10,
  top: "36%",
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  color: "#0070ba",
  cursor: "pointer",
  fontSize: 14,
  padding: 0,
};

const linkButtonStyle = {
  background: "none",
  border: "none",
  color: "#0070ba",
  cursor: "pointer",
  textDecoration: "underline",
  padding: 0,
  fontSize: "14px",
};

export default LoginForm;